import cookieService from "./cookie"

let logoutCallback = null

const authService = {
    logout: () => {
        cookieService.delete("token", { path: "/" })
        if (logoutCallback) logoutCallback()
        // window.location.href = "/user/auth/signin"
    },
    getToken: () => {
        return cookieService.get("token", { path: "/" })
    },

    registerLogout(cb) {
        logoutCallback = cb
    }
}

export default authService
